<template>
  <div>
    <b-navbar toggleable="sm" type="light" variant="light" class="row">
      <b-navbar-brand>
        <router-link to="/">
          <span class="navbar-brand col">Lettre Compte Triple</span>
        </router-link>
      </b-navbar-brand>
      <b-navbar-toggle target="bottom-collapse"></b-navbar-toggle>

      <b-collapse id="bottom-collapse" is-nav class="col">
        <b-navbar-nav>
          <router-link to="/rules">
              <span class="nav-link">Règle</span>
          </router-link>
        </b-navbar-nav>
        <b-navbar-nav>
          <router-link to="/contact" v-if="username">
              <span class="nav-link">Contact</span>
            </router-link>
        </b-navbar-nav>
        <b-navbar-nav>
          <router-link to="/mention-legales">
              <span class="nav-link">Mentions légales</span>
            </router-link>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import iam from '../iam';

export default {
  name: 'Bottom-Nav',
  data() {
    return {
      username: iam.getConnectedUser() ? iam.getConnectedUser().username : undefined,
    };
  },
};
</script>

<style>
.navbar {
  font-size: 0.85rem;
}
.navbar-brand {
  font-size: 0.85rem;
}
.nav-link{
  font-size: 0.85rem;
}
</style>



// WEBPACK FOOTER //
// src/components/BottomNav.vue